import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';

export const UPSERT_INCOME_MK = 'upsertIncomeMutation';

const upsertIncome = (body): Promise<null> => {
  return authFetch('/Consumer/IncomeUpdate/Save', {
    method: 'POST',
    ...httpBodyOptions(body, true),
  });
};

interface Params {
  clientId: string;
}

export const useUpsertIncomeMutation = ({ clientId }: Params) => {
  const queryClient = useQueryClient();

  return useMutation(upsertIncome, {
    mutationKey: [UPSERT_INCOME_MK],

    async onSuccess() {
      await queryClient.refetchQueries(queryKeys.income(clientId));
    },
  });
};
